<div class="container">
  <div class="row">
    <div class="col-12">

      <div class="build-configs">
        <dx-data-grid
          id="gridContainer"
          [dataSource]="configs"
          [allowColumnReordering]="true"
          [allowColumnResizing]="true"
          [remoteOperations]="false"
          (onRowDblClick)="onRowDoubleClick($event)"
          (onToolbarPreparing)="onToolbarPreparing($event)">

          <dxo-group-panel [visible]="true"></dxo-group-panel>
          <dxo-grouping [allowCollapsing]="true" [autoExpandAll]="false"></dxo-grouping>

          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-paging [enabled]="true"></dxo-paging>
          <dxo-state-storing [enabled]="true" storageKey="build-configs.v3"
                             type="localStorage"></dxo-state-storing>

          <dxi-column caption="" cellTemplate="detail-link" width="30px"></dxi-column>
          <dxi-column [showWhenGrouped]="false" caption="Customer" dataField="name" groupIndex="0"
                      width="200px"></dxi-column>
          <dxi-column dataField="application" width="100px"></dxi-column>
          <dxi-column dataField="externalId"></dxi-column>
          <dxi-column dataField="gitRepository"></dxi-column>

          <div *dxTemplate="let r of 'detail-link'">
            <a [routerLink]="['/build-configs', r.data.id]" class="detail-link"><i class="fa fa-eye"></i></a>
          </div>
        </dx-data-grid>


      </div>

    </div>
  </div>
</div>


<dx-popup (onHidden)="newBuildConfig = false" *ngIf="newBuildConfig" [closeOnOutsideClick]="true"
          [visible]="newBuildConfig" height="auto"
          title="New Build Config" width="auto">

  <form (ngSubmit)="saveBuildConfig()" [formGroup]="formBuildConfig">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="name">Customer Name</label>
            <div class="form-component">
              <dx-text-box [inputAttr]="{id: 'customer'}" [isValid]="isValid(formBuildConfig, 'customer')"
                           formControlName="customer"></dx-text-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="application">Application</label>
            <div class="form-component">
              <dx-select-box [dataSource]="applications" [inputAttr]="{id: 'application'}"
                             [isValid]="isValid(formBuildConfig, 'application')" [searchEnabled]="true"
                             [searchTimeout]="0"
                             [showDataBeforeSearch]="true"
                             formControlName="application"></dx-select-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="gitlabInstance">Git Repository</label>
            <div class="form-component">
              <dx-select-box [dataSource]="gitlabInstances" [inputAttr]="{id: 'gitlabInstance'}"
                             [isValid]="isValid(formBuildConfig, 'gitlabInstance')" [searchEnabled]="true" [searchTimeout]="0"
                             [showDataBeforeSearch]="true"
                             displayExpr="name"
                             formControlName="gitlabInstance"></dx-select-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="gitRepository">Git Repository</label>
            <div class="form-component">
              <dx-text-box [inputAttr]="{id: 'gitRepository'}" [isValid]="isValid(formBuildConfig, 'gitRepository')"
                           formControlName="gitRepository"></dx-text-box>
            </div>
          </div>
        </div>


        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="jiraProject">Jira</label>
            <div class="form-component">
              <dx-select-box [dataSource]="jiraProjects"
                             [displayExpr]="getJiraDisplayText" [inputAttr]="{id: 'jiraProject'}"
                             [isValid]="isValid(formBuildConfig, 'jiraProject')"
                             [searchEnabled]="true"
                             [searchTimeout]="0"
                             [showDataBeforeSearch]="true" formControlName="jiraProject" valueExpr="this">
              </dx-select-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-item">
            <label class="label required col-4 col-xl-3" for="jiraCustomerLabel">Jira Label</label>
            <div class="form-component">
              <dx-text-box [inputAttr]="{id: 'jiraCustomerLabel'}"
                           [isValid]="isValid(formBuildConfig, 'jiraCustomerLabel')"
                           formControlName="jiraCustomerLabel"></dx-text-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-item">
            <label class="label col-4 col-xl-3" for="releaseNotesEmail">Release Note Email</label>
            <div class="form-component">
              <dx-text-box [inputAttr]="{id: 'releaseNotesEmail'}"
                           [isValid]="isValid(formBuildConfig, 'releaseNotesEmail')"
                           formControlName="releaseNotesEmail"></dx-text-box>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-end">
            <div class="mr-1">
              <dx-button [disabled]="!formBuildConfig.valid" [useSubmitBehavior]="true" text="Save"></dx-button>
            </div>
            <div>
              <dx-button (onClick)="newBuildConfig = false" [useSubmitBehavior]="false" text="Cancel"></dx-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</dx-popup>
